// A brief, self-dismissing confirmation message. Fire-and-forget: `toast('Copied')`
// drops a pill near the bottom of the screen that fades in, holds, then fades out
// and removes itself. Self-contained — inline styles, appends to document.body, no
// shared stylesheet or global init (like utils/ripple).

const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)')

export const toast = (message: string, ms = 1800) => {
    const el = document.createElement('div')
    el.textContent = message
    Object.assign(el.style, {
        position: 'fixed',
        left: '50%',
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 32px)',
        transform: 'translate(-50%, 12px)',
        maxWidth: 'calc(100vw - 48px)',
        padding: '10px 18px',
        borderRadius: '999px',
        background: 'rgba(34, 28, 64, 0.92)',
        color: '#fff',
        fontSize: '0.9375rem',
        fontWeight: '600',
        lineHeight: '1',
        textAlign: 'center',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.25)',
        zIndex: '9999',
        opacity: '0',
        pointerEvents: 'none',
        transition: reduce?.matches ? 'none' : 'opacity 0.2s ease, transform 0.2s ease',
    })
    document.body.appendChild(el)

    requestAnimationFrame(() => {
        el.style.opacity = '1'
        el.style.transform = 'translate(-50%, 0)'
    })

    setTimeout(() => {
        el.style.opacity = '0'
        el.style.transform = 'translate(-50%, 12px)'
        el.addEventListener('transitionend', () => el.remove(), { once: true })
        setTimeout(() => el.remove(), 400) // safety net if transitionend never fires
    }, ms)
}
